import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import EmailSignatureService from '../../services/EmailSignatureService';
import { Loader } from '../../components/Loader/Loader';
import { FIRST_LOAD } from '../../constants/GeneralConstants';
import { isDesktop } from 'react-device-detect';
import { OTP } from '../../components/SignMethods/OTP/OTP';
import { BatchContext } from '../../contexts/BatchContext';
import { Back } from '../../components/Back/Back';
import { ArrowIcon } from '../../components/SvgComponents/ArrowIcon/ArrowIcon';
import { ShowOtpByCallWarningModal } from '../../components/Modals/ShowOtpByCallWarningModal/ShowOtpByCallWarningModal';
import { EnterPhoneNumberIcon } from '../../components/SvgComponents/EnterPhoneNumberIcon/EnterPhoneNumberIcon';
import { AdditionalSignaturesFinalFlow } from '../../components/SignMethods/AdditionalSignaturesFinalFlow/AdditionalSignaturesFinalFlow';
import { AdditionalSignaturesContext } from '../../contexts/AdditionalSignaturesContext';
import { useOtpInput } from '../../hooks/useOtpInput';

export const SendOtpCall = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [otpCode, setOtpCode] = useState('');
  const [emailId, setEmailId] = useState('');
  const [showOtpErrorMessage, setShowOtpErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpFlow, setOTPFlow] = useState(false);
  const documentsState = location.state.documents;
  const requestId = location.state.requestId;
  const documents = Array.isArray(documentsState) ? documentsState[0] : documentsState;
  const email = documents.SignerDTO.eMail;
  const widthIcon = 150;
  const heightIcon = 147;
  const [openShowOtpByCallWarningModal, setOpenShowOtpByCallWarningModal] = useState(true);

  const { remainingBatchDocuments, setBatchOTP, batchAttachedImages, isBatchMultisignature } = useContext(BatchContext);

  const [completeAdditionalSignaturesFlow, setCompleteAdditionalSignaturesFlow] = useState(false);
  const { isSignatureBoxesFlow } = useContext(AdditionalSignaturesContext);

  // On Init
  useEffect(() => {
    setPhoneNumber(location.state.phoneNumber);
    setEmailId(location.state.emailId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBack = () => {
    localStorage.setItem(FIRST_LOAD, "true");
    if (location.state?.isPhoneNumberCustom) {
      const link = '/customsms';
      navigate(link, {
        state: {
          documents,
          emailId
        }
      });
      return;
    }

    let link = '/document';
    if (documents.SignerDTO.Form && documents.SignerDTO.Form.FormDisplay.toLowerCase() === "onpreview") link = "/document-questions";

    if (isBatchMultisignature) link = '/documents';

    navigate(link, {
      state: {
        documents,
        emailId
      }
    });
  }

  const handleSendSmsCode = () => {
    setLoading(true);
    const body = {
      "OTP": otpCode
    };

    if (documents.SignerDTO.OneShot) {
      let link = "/sign";
      if (documents.SignerDTO.AttachIdDocImages && typeof attachedImages === 'undefined' && !batchAttachedImages) {
        link = "/attach-images";
      } else {
        if (isSignatureBoxesFlow) return setCompleteAdditionalSignaturesFlow(true);
      }

      navigate(link, {
        state: {
          documents,
          emailId,
          otpCode,
          requestId
        }
      });

      return;
    }
    EmailSignatureService.sendOTPCode(emailId, body)
      .then(response => {
        if (response) {
          setLoading(false);
          if (remainingBatchDocuments > 0) setBatchOTP(otpCode);

          const { SkipSigDraw } = documents.SignerDTO;

          let link = '/sign';
          if (documents.SignerDTO.AttachIdDocImages && typeof attachedImages === 'undefined' && !batchAttachedImages) {
            link = "/attach-images";
          } else {
            if (isSignatureBoxesFlow) return setCompleteAdditionalSignaturesFlow(true);
          }

           // OTP Flow
          if (SkipSigDraw && !documents.SignerDTO.AttachIdDocImages) return setOTPFlow(true);

          navigate(link, {
            state: {
              documents,
              emailId,
              otpCode,
            }
          });
          return;
        }
        setLoading(false);
        setShowOtpErrorMessage(true);
      })
      .catch(err => {
        setLoading(false);
        setShowOtpErrorMessage(true);
        console.log(err);
      });
  };

  const handlerSupportTicket = () => {
    setLoading(true);
    navigate("/support", {
      state: {
        documents: location.state.documents,
        phoneNumber: phoneNumber,
        emailId: emailId,
        isCallChannel: true,
      }
    });
  };

  const otpInputProps = useOtpInput(setOtpCode);

  return (
    <>
      {loading && <Loader />}
      {completeAdditionalSignaturesFlow && <AdditionalSignaturesFinalFlow otpCode={otpCode} emailId={emailId} setLoadingMorePages={setLoading} />}
      {otpFlow && <OTP signerGuid={documents.SignerDTO.SignerGUI} otpCode={otpCode} emailId={emailId} docGuid={documents.DocGUI} email={email} setLoadingMorePages={setLoading} />}
      {!loading &&
        <Container className="document-preview-container">
          <Row>
            <Col md={12} lg={12} className="document-preview-title">
              <Back handleBack={handleBack} />
            </Col>
            <Col md={2} xs={1}></Col>
            <Col md={12} xs={10} lg={12} className="justify-content-center container-sms-box-2">
              <Row>
                {isDesktop &&
                  <Col md={4} lg={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <EnterPhoneNumberIcon width={widthIcon} height={heightIcon} />
                  </Col>
                }
                <Col md={8} lg={5} className="col-align">
                  <h4 className="sms-title">{t('sms.title')}</h4><br></br>
                  <p>{t('sms.custom_description2_call')}</p>
                  <p>{t('sms.custom_description_call')}</p>
                  <Form className="phone-number-form">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control className="phone-number-input-disabled" type="text" value={phoneNumber} disabled />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control className="phone-number-input" isInvalid={`${showOtpErrorMessage ? 'error' : ''}`} {...otpInputProps} placeholder={t('personal_code.enter_the_code')} name="otpCode" value={otpCode} onChange={e => setOtpCode(e.target.value)} />
                    </Form.Group>
                  </Form>
                  {
                    showOtpErrorMessage &&
                    <div className="error-message align-error-message">
                      {t('sms.invalid_code')}
                    </div>
                  }
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={4} xs={0}></Col>
            <Col md={4} xs={12} className="button-margin button-only">
              <button type="button" className="btn btn-primary btn-active phone-number-button" disabled={otpCode.length === 0} onClick={handleSendSmsCode}>
                <span className="cancel-text">{t('general.sign')}</span>
                <ArrowIcon />
              </button>
            </Col>
          </Row>
          <Row>
            <Col><br></br>
              <div className="audio-label">
                <span onClick={() => handlerSupportTicket()}>{t('sms.support')}</span>
              </div>
            </Col>
          </Row>
          <ShowOtpByCallWarningModal openShowOtpByCallWarningModal={openShowOtpByCallWarningModal} setOpenShowOtpByCallWarningModal={setOpenShowOtpByCallWarningModal} />
        </Container>
      }
    </>
  );
}

